import { FEATURES } from "@/data/content";
import EditableText from "./EditableText";

export const Features = () => {
  return (
    <section id="features" data-testid="features-section" className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#EADDFF]/40">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16 sm:mb-20">
          <EditableText k="features.eyebrow" fallback="What lives inside" className="eyebrow" data-testid="features-eyebrow" />
          <h2 className="editorial-display mt-5 text-4xl sm:text-5xl lg:text-6xl text-[#0B0A4A]" data-testid="features-heading">
            <EditableText
              k="features.heading"
              fallback="Everything you've been stitching together in one quiet, intelligent place."
              multiline
            />
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#0B0A4A]/75 font-sans max-w-2xl" data-testid="features-subheading">
            <EditableText
              k="features.subheading"
              fallback="Cycle, hormones, nutrition, fitness, recovery, symptoms, cravings, community — woven together by an AI built for the female body."
              multiline
            />
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[minmax(220px,_auto)] gap-5" data-testid="features-grid">
          {FEATURES.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <article
                key={feature.title}
                data-testid={`feature-card-${i}`}
                className={`group relative ${feature.span} rounded-3xl p-7 sm:p-8 transition-all duration-500 hover:-translate-y-1 ${
                  feature.accent
                    ? "bg-[#0B0A4A] text-[#F4ECFF] shadow-[0_30px_80px_-40px_rgba(11,10,74,0.6)]"
                    : "bg-white/70 backdrop-blur-sm border border-[#E0D0F5] hover:border-[#3E1A7A]/50 hover:shadow-lg"
                }`}
              >
                {feature.accent && (
                  <div
                    className="absolute -top-20 -right-20 w-64 h-64 rounded-full opacity-40 blur-3xl pointer-events-none"
                    style={{ background: "radial-gradient(circle, #B87CFF 0%, transparent 70%)" }}
                  />
                )}
                <div className="relative flex flex-col h-full">
                  <span
                    className={`inline-flex items-center justify-center w-11 h-11 rounded-2xl ${
                      feature.accent ? "bg-[#B87CFF]/25 text-[#B87CFF]" : "bg-[#EADDFF] text-[#3E1A7A]"
                    }`}
                  >
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </span>

                  <h3
                    className={`font-serif text-2xl sm:text-3xl mt-6 leading-tight ${
                      feature.accent ? "text-[#F4ECFF]" : "text-[#0B0A4A]"
                    }`}
                  >
                    <EditableText k={`feature.${i}.title`} fallback={feature.title} />
                  </h3>

                  <p
                    className={`mt-3 text-sm sm:text-base leading-relaxed font-sans ${
                      feature.accent ? "text-[#F4ECFF]/80" : "text-[#0B0A4A]/70"
                    }`}
                  >
                    <EditableText k={`feature.${i}.blurb`} fallback={feature.blurb} multiline />
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
